import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mainHomeWrapper" }
const _hoisted_2 = { class: "farmScreen" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "neverStaked"
}
const _hoisted_5 = {
  key: 0,
  class: "stats"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Dark Skellies Staking", -1)
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Total Staked", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Min. Value Locked", -1)
const _hoisted_10 = { class: "chooseScreenOptions" }
const _hoisted_11 = { class: "flex items-stretch stakeSection" }
const _hoisted_12 = {
  key: 0,
  class: "nftBox"
}
const _hoisted_13 = { class: "flex flex-wrap" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "nftTitleBox" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode("Wallet Skellies "),
    /*#__PURE__*/_createElementVNode("b", null, "(0)")
  ])
], -1)
const _hoisted_15 = { class: "outerCard" }
const _hoisted_16 = {
  class: "flex gapThis",
  style: {"margin-top":"50px"}
}
const _hoisted_17 = {
  key: 0,
  class: "loadingAnimation"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", { style: {"font-style":"italic","opacity":"0.5","color":"#f1f1f1","text-align":"center"} }, " Looks like you've never staked with us before! Click the button below to verify your account with the smart contract and begin staking (roughly 0.018 SOL). ", -1)
const _hoisted_19 = {
  key: 1,
  class: "nftBox"
}
const _hoisted_20 = { class: "flex flex-wrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "nftTitleBox" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode("Unstaked Skellies "),
    /*#__PURE__*/_createElementVNode("b", null, "(0)")
  ])
], -1)
const _hoisted_22 = { class: "outerCard" }
const _hoisted_23 = {
  class: "flex gapThis",
  style: {"margin-top":"50px"}
}
const _hoisted_24 = {
  key: 0,
  class: "loadingAnimation"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h4", { style: {"font-style":"italic","opacity":"0.5","color":"#f1f1f1","text-align":"center"} }, " Looks like you've never staked with us before! Click the button below to verify your account with the smart contract and begin staking (roughly 0.018 SOL). ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vault = _resolveComponent("Vault")!
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.farmerAcc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Vault, {
              key: _ctx.farmerAcc,
              class: "mb-10",
              vault: _ctx.farmerAcc.vault.toBase58(),
              reward: _ctx.farmerAcc.rewardA,
              onSelectedWalletNft: _ctx.handleNewSelectedNFT
            }, null, 8, ["vault", "reward", "onSelectedWalletNft"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!_ctx.wallet?.publicKey?.toBase58())
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _hoisted_8,
                      _createElementVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.farmAcc.gemsStaked), 1),
                        _createElementVNode("b", null, "/" + _toDisplayString(_ctx.hashlist.length), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_9,
                      _createElementVNode("h3", null, "$" + _toDisplayString((+_ctx.floorPrice * +_ctx.solPrice * _ctx.farmAcc.gemsStaked).toFixed(0)), 1)
                    ])
                  ]),
                  _createVNode(_component_ConfigPane)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showScreen = 'Wallet')),
                      style: _normalizeStyle(_ctx.showScreen === 'Wallet' ? {background: '#f1f1f1',color: '#1e1e1e'} : {background: '#1e1e1e',color: '#f1f1f1'})
                    }, "Wallet (0)", 4),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showScreen = 'Vault')),
                      style: _normalizeStyle(_ctx.showScreen !== 'Wallet' ? {background: '#f1f1f1',color: '#1e1e1e'} : {background: '#1e1e1e',color: '#f1f1f1'})
                    }, "Vault (0)", 4)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.showScreen === 'Wallet')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                (_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_18,
                                      _createElementVNode("button", {
                                        class: "big-button",
                                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                                      }, " Verify ")
                                    ], 64))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showScreen === 'Vault')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                (_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_25,
                                      _createElementVNode("button", {
                                        class: "big-button",
                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                                      }, " Verify ")
                                    ], 64))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
          ]))
    ]),
    (_ctx.showAlert === true)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          message: 'Must stake with a Ra/Anubis',
          type: 'error'
        }))
      : _createCommentVNode("", true)
  ]))
}